export default __webpack_public_path__ + "static/media/2.5-million-registration.e52b5df9.webp";